import NotificationSettingView from './views/NotificationSettingView/NotificationSettingView';
import NotificationSettingViewController from './views/NotificationSettingViewController/NotificationSettingViewController';
import { initNotificationManagement } from './utilities/initHelper';// eslint-disable-line

export default {
  NotificationSettingView,
  NotificationSettingViewController,
  initNotificationManagement,
};
